import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🏎️", key: "createVehicle" },
  { emoji: "🔧", key: "editVehicle" },
  { emoji: "⚔️", key: "both" },
]

export default function CarsStartHerePage() {
  return <RadioCardListPage translationKey="carsStartHere" options={OPTIONS} />
}
